import React, { useState, useRef, useCallback } from 'react';
import styles from './FJSearchMatch.module.less';
import SearchIcon from '../../../../../assets/svg/search.svg?react';
import FJLocalStore from '../../../../../store/FJLocalStore.js';
import DeleteSearchIcon from '../../../../../assets/svg/delete-x.svg?react';
import classNames from 'classnames';
import DownIcon from '../../../../../assets/svg/transcribe/down.svg?react';
import UpIcon from '../../../../../assets/svg/transcribe/up.svg?react';

const FJSearchMatch = props => {
    const { className, searchText, onSearch, currentMathIndex, matchIndexList = [], onNext, onPrevious } = props;

    const _input = useRef();
    const [isFocus, setIsFocus] = useState(false);

    const _onInputKeyDown = e => {
        e.stopPropagation();
        // 阻止 Ctrl+Z (undo) 和 Ctrl+Y (redo)
        if ((e.ctrlKey || e.metaKey) && (e.key === 'z' || e.key === 'y')) {
            e.preventDefault();
        } else if (e.key === 'Enter') {
            onNext && onNext();
        }
    };
    const _onInputChange = e => {
        if (!isFocus) {
            e.preventDefault();
            return;
        }
        onSearch && onSearch(e.target.value);
    };

    const _onFocus = () => {
        setIsFocus(true);
    };

    const _onBlur = () => {
        setIsFocus(false);
    };

    const _onDeleteSearch = useCallback(() => {
        onSearch && onSearch('');
    }, []);

    const _onNext = () => {
        if (currentMathIndex === -1 || currentMathIndex === matchIndexList.length - 1) return;
        onNext && onNext();
    };

    const _onPrevious = () => {
        if (currentMathIndex === -1 || currentMathIndex === 0) return;
        onPrevious && onPrevious();
    };

    const _renderMatch = () => {
        if (!searchText) return null;
        return (
            <div className={styles.match_box}>
                <div className={styles.match_number}>
                    {currentMathIndex + 1} / {matchIndexList.length}
                </div>
                <div className={styles.line} style={{ marginRight: 4 }} />
                <UpIcon
                    className={classNames(styles.arrow_icon, {
                        [styles.disable]: currentMathIndex === -1 || currentMathIndex === 0,
                    })}
                    style={{ marginRight: 4 }}
                    onClick={_onPrevious}
                />
                <DownIcon
                    className={classNames(styles.arrow_icon, {
                        [styles.disable]: currentMathIndex === -1 || currentMathIndex === matchIndexList.length - 1,
                    })}
                    onClick={_onNext}
                />
                <div className={styles.line} style={{ marginLeft: 4 }} />
            </div>
        );
    };

    let _inputWidth = 100;
    if (matchIndexList.length >= 100) {
        _inputWidth = 90;
    } else if (matchIndexList.length >= 10) {
        _inputWidth = 100;
    }

    return (
        <div className={classNames(styles.search_box, { [styles.focus]: isFocus }, className)}>
            <SearchIcon className={styles.icon} />
            <input
                style={{ width: searchText ? _inputWidth : 230 }}
                className={styles.input}
                value={searchText}
                ref={_input}
                onKeyDown={_onInputKeyDown}
                onChange={_onInputChange}
                onFocus={_onFocus}
                onBlur={_onBlur}
                placeholder={FJLocalStore._('search')}
                maxLength={100}
            />
            {_renderMatch()}
            {searchText && (
                <div className={styles.delete_search}>
                    <DeleteSearchIcon onClick={_onDeleteSearch} />
                </div>
            )}
        </div>
    );
};

export default FJSearchMatch;
